import React from 'react';
import { Button, Alert, AlertTitle } from '@mui/material';
import Can from "../Can";

const themeColor = '#a71e3b';

function ReqLabConfirm(props) {
    if (props.isSubmitble) {
        if (!props.isSubmitted) {
            return (
                <Can
                    role={props.apiAuthGroups}
                    perform="labRequest-page:confirm"
                    yes={() => (
                        <Button
                            variant="contained"
                            type="submit"
                            sx={{
                                backgroundColor: themeColor,
                                '&:hover': { backgroundColor: '#8a1830' }
                            }}
                        >
                            {props.buttonDescription}
                        </Button>
                    )}
                    no={() => (
                        <Alert severity="warning" sx={{ mb: 2 }}>
                            <AlertTitle>Funzionalità di cancellazione Laboratorio Virtuale non abilitata</AlertTitle>
                            La funzionalità di cancellazione Laboratorio Virtuale è in corso di attivazione e sarà a breve disponibile.
                        </Alert>
                    )}
                />
            );
        } else {
            if (props.statusRequest === "success") {
                return (
                    <>
                        <Alert severity="success" sx={{ mb: 2 }}>
                            <AlertTitle>Cancellazione del Laboratorio Virtuale acquisita con successo!</AlertTitle>
                            Il Laboratorio Virtuale richiesto è ora in stato "Dropped".
                        </Alert>
                        <Button
                            href="/"
                            variant="contained"
                            sx={{
                                backgroundColor: themeColor,
                                '&:hover': { backgroundColor: '#8a1830' }
                            }}
                        >
                            Torna alla Home Page
                        </Button>
                    </>
                );
            } else {
                return (
                    <>
                        <Alert severity="error" sx={{ mb: 2 }}>
                            <AlertTitle>Si è verificato un errore!</AlertTitle>
                            Contattare l'assistenza.
                        </Alert>
                        <Button
                            href="/"
                            variant="contained"
                            sx={{
                                backgroundColor: themeColor,
                                '&:hover': { backgroundColor: '#8a1830' }
                            }}
                        >
                            Torna alla Home Page
                        </Button>
                    </>
                );
            }
        }
    } else {
        return (
            <Button
                variant="contained"
                type="submit"
                sx={{
                    backgroundColor: themeColor,
                    '&:hover': { backgroundColor: '#8a1830' }
                }}
            >
                {props.buttonDescription}
            </Button>
        );
    }
}

export default ReqLabConfirm;
